export default __webpack_public_path__ + "f36ce27.png";